import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OrderDetailTitle } from 'src/pages/orders/components/orderDetails/OrderDetails.styled';
import SetsOrderDetail from './setsOrderDetail/SetsOrderDetail';
import ExtrasOrderDetail from './extrasOrderDetail/ExtrasOrderDetail';
import BillingDetails from './billingDetails/BillingDetails';
import TissueIcon from 'src/assets/images/TissueIcon.svg';
import NonTissueIcon from 'src/assets/images/NonTissueIcon.svg';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import smallarrow from 'src/assets/images/SmallDownArrow.svg';
import {
    Text,
    AddIcon,
} from 'src/common/refactoredComponents/addProductMethods/ProductsAddMethods.styled';
import ExpandAll from 'src/assets/images/ExpandAll.svg';
import CollapseAll from 'src/assets/images/CollapseAll.svg';

import {
    AccountTimeDetails,
    AccountStatusDetails,
    AccountOrderDiv,
    AccountOrderMobileDiv,
    AccountMobileTitle,
    AccountGridContainer,
    PriceTitle,
    AccountOrderDetails,
    AccountBillingDetails,
    AccountTitle,
    AccountGrid,
    AccountDetails,
    AccountSubGrid,
    AccountSubGridContainer,
    ImageContainer,
    OrderDetailMainContainer,
    CartActionItems,
} from './OrderDetailTab.styled';
import {
    convertToMMddYYYYForRVM,
    notesTimeFormatter,
    getDisplayDate,
} from 'src/utils/dateUtils';
import { ORDER_LIST_ORDER_STATUS_ICONS } from 'src/constants/filterConstants';
import ListViewContainer from 'src/common/organisms/listViewContainer/index';
import { OrderDetailFooterContainer } from 'src/pages/orders/components/orderDetails/OrderDetails.styled';
import { WrapperContainer } from 'src/pages/orders/components/orderDetails/orderSummary/orderSummaryDetails/OrderSummaryDetailsCard.styled';
import { InvoiceCreatedDetail } from 'src/pages/orders/components/orderDetails/orderSummary/orderSummaryDetails/OrderSummaryDetails.styled';
import {
    convertTime24To12,
    countTotalBOM,
    getTotalCount,
    itemListViewVisibility,
    setCurrencyFormat,
    getTotalQuantity,
    expandCollapse,
    logErrorToConsole,
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { sizes } from 'src/styles/Media.styled';
import { priceFormatObj } from 'src/pages/consignmentBilling/utils/eventHandlerUtil';
import AccountDetailsSection from './AccountDetails/AccountDetailsSection';
import { setItemListView } from 'src/pages/orders/redux/actions';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import ItemListView from 'src/pages/scheduleSurgery/components/surgery/ItemListview';
import ConsignmentTermData from '../orderSummary/consignmentTerm/ConsignmentTerm';
import ProcedureDetails from '../orderSummary/procedureDetails/ProcedureDetails';
import SurgeryNotes from 'src/pages/orders/components/orderDetails/orderSummary/surgeryNotes/SurgeryNotes.jsx';
import { CollapsableCardImageContainer } from 'src/styles/CommonStyles.styled';
import { isIpad, isMobileView } from 'src/utils/util';
import CondensedMobileViewList from 'src/common/refactoredComponents/condensedMobileView/CondensedMobileViewList';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const OrderDetailTab = ({ handleSetItemClick, ordersList }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [expandedCard, setExpandedCard] = useState({
        sets: true,
        extras: true,
        billingDetails: true,
        implants: true,
        instruments: true,
        isProcedureDetails: true,
        isSurgeryNotes: true,
        productsView: true,
    });

    const [modifyDate, setModifyDate] = useState('');
    const [modifyTime, setModifyTime] = useState('');
    const [lastClickedActionItemList, setLastClickedActionItemList] = useState('collapse');
    const [lastClickedAction, setLastClickedAction] = useState('collapse');
    const [notes, setNotes] = useState([]);
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    useEffectWithErrorLogging(() => {
        if (lastModifiedDate && lastModifiedDate !== '') {
            setModifyDate(getDisplayDate(new Date(lastModifiedDate)));
            setModifyTime(convertTime24To12(new Date(lastModifiedDate)));
        }
    }, [lastModifiedDate]);

    const { orderDetails, orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const {
        consignmentBillingCustomerNotes,
        consignmentReplenishmentNotes,
        usageReplenishmentcustomerNotes,
        usagecustomerNotes,
        // accountDetails, //change when Account details come from API
    } = orderBasicDetails || {};

    const isItemListView = useSelector(
        (state) => state.orderSummaryReducer.isItemListView
    );
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));
    const implantProducts = useSelector(
        (state) => state.orderSummaryReducer.implantProducts
    );
    const instrumentProducts = useSelector(
        (state) => state.orderSummaryReducer.instrumentProducts
    );
    const winWidth = window.innerWidth;

    const {
        sets,
        extras,
        billingDetails,
        implants,
        instruments,
        isProcedureDetails,
        isSurgeryNotes,
    } = expandedCard;

    const isSet = orderDetails
        ? orderDetails?.filter((order) => order.isSet === true)
        : [];
    const isExtras = orderDetails
        ? orderDetails?.filter((order) => order.isSet === false)
        : [];
    const {
        orderDescription,
        lastModifiedBy,
        lastModifiedDate,
        createdBy,
        createdByTime,
    } = useSelector((state) => ({
        orderDescription:
            state.orderSummaryReducer.orderBasicDetails?.orderDescription,
        lastModifiedBy:
            state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                ?.lastModifiedBy,
        lastModifiedDate:
            state.orderSummaryReducer.orderBasicDetails?.orderSummaryDetail
                ?.lastModifiedDate,
        createdBy: state.orderSummaryReducer.createdBy,
        createdByTime: state.orderSummaryReducer.createdByTime,
    }));
    const products = useSelector(
        (state) => state.orderSummaryReducer.orderDetails
    );

    const [shippingStatusSVG, setShippingStatusSVG] = useState(null);

    const shippingStatus = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.orderStatusDescription
    );
    const { iconList } = ORDER_LIST_ORDER_STATUS_ICONS();

    const { isLongTermConsignment, isShortTermConsignment } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const { procedureDetail } = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails
    );

    const [expandedProducts, setExpandedProducts] = useState(new Set());
    const [expandedProductsItemList, setExpandedProductsItemList] = useState(
        new Set()
    );
    const [itemListData, setItemListData] = useState([]);

    useEffectWithErrorLogging(() => {
        if (products?.length > 0) {
            let productData = [];
            products.map((e) => {
                if (e.isSet) {
                    e.productMoreDetails?.billOfMaterials?.length > 0 &&
                        e.productMoreDetails?.billOfMaterials?.map((item) => {
                            productData.push(item);
                        });
                }
                if (!e.isSet) {
                    productData.push(e);
                }
            });
            setItemListData(productData);
        }
    }, [products]);

    const toggleProduct = (productId) => {
        setExpandedProducts((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(productId)) {
                newSet.delete(productId);
            } else {
                newSet.add(productId);
            }
            return newSet;
        });
    };

    const toggleProductItemList = (productId) => {
        setExpandedProductsItemList((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(productId)) {
                newSet.delete(productId);
            } else {
                newSet.add(productId);
            }
            return newSet;
        });
    };

    // Expand all products
    const expandAllItemList = () => {
        setLastClickedActionItemList('expand');
        let productData = [];
        if (isItemListView) {
            products.map((e) => {
                if (e.isSet) {
                    e.productMoreDetails?.billOfMaterials?.length > 0 &&
                        e.productMoreDetails?.billOfMaterials?.map((item) => {
                            productData.push(item);
                        });
                }
                if (!e.isSet) {
                    productData.push(e);
                }
            });
        }
        setExpandedProductsItemList(
            new Set(
                isItemListView
                    ? productData.map((product) => product.productKey)
                    : products.map((product) => product.productKey)
            )
        );
    };

    // Collapse all products
    const collapseAllItemList = () => {
        setLastClickedActionItemList('collapse');
        setExpandedProductsItemList(new Set());
    };
    // Expand all products
    const expandAll = () => {
        setLastClickedAction('expand');
        let productData = [];
        if (isItemListView) {
            products.map((e) => {
                if (e.isSet) {
                    e.productMoreDetails?.billOfMaterials?.length > 0 &&
                        e.productMoreDetails?.billOfMaterials?.map((item) => {
                            productData.push(item);
                        });
                }
                if (!e.isSet) {
                    productData.push(e);
                }
            });
        }
        setExpandedProducts(
            new Set(
                isItemListView
                    ? productData.map((product) => product.productKey)
                    : products.map((product) => product.productKey)
            )
        );
    };

    // Collapse all products
    const collapseAll = () => {
        setLastClickedAction('collapse');
        setExpandedProducts(new Set());
    };
    useEffectWithErrorLogging(()=>{
        if(expandedProducts?.size ===0 && products?.length>0){
            setLastClickedAction('collapse');
        }
        if(expandedProducts?.size === products?.length && products?.length>0){
            setLastClickedAction('expand');
        }
    },[expandedProducts]);
    useEffectWithErrorLogging(()=>{
        let productData = [];
        if (isItemListView) {
            products.map((e) => {
                if (e.isSet) {
                    e.productMoreDetails?.billOfMaterials?.length > 0 &&
                        e.productMoreDetails?.billOfMaterials?.map((item) => {
                            productData.push(item);
                        });
                }
                if (!e.isSet) {
                    productData.push(e);
                }
            });
        }
        if(expandedProductsItemList?.size ===0 && productData?.length>0){
            setLastClickedActionItemList('collapse');
        }
        if(expandedProductsItemList?.size === productData?.length && productData?.length>0){
            setLastClickedActionItemList('expand');
        }
    },[expandedProductsItemList]);
    useEffectWithErrorLogging(() => {
        iconList.forEach((statusType) => {
            if (statusType.description === shippingStatus) {
                setShippingStatusSVG(statusType.filterIconUrl);
            }
        });
    }, [shippingStatus]);

    useEffectWithErrorLogging(() => {
        let cusUsageNotes =
            usageReplenishmentcustomerNotes?.length > 0
                ? [
                      {
                          notesAr: [...usageReplenishmentcustomerNotes],
                          header: t('common.summaryUsageReplenishNote'),
                      },
                  ]
                : [];
        let UsageRepNotes =
            usagecustomerNotes?.length > 0
                ? [
                      {
                          notesAr: [...usagecustomerNotes],
                          header: t('common.summaryUsageCustomerCareNote'),
                      },
                  ]
                : [];

        let cusConBilNotes =
            consignmentBillingCustomerNotes?.length > 0
                ? [
                      {
                          notesAr: [...consignmentBillingCustomerNotes],
                          header: t('reportUsage.consignmentBillingNotes'),
                      },
                  ]
                : [];
        let conBilRepNotes =
            consignmentReplenishmentNotes?.length > 0
                ? [
                      {
                          notesAr: [...consignmentReplenishmentNotes],
                          header: t(
                              'reportUsage.consignmentReplenishmentNotes'
                          ),
                      },
                  ]
                : [];
        setNotes([
            ...cusConBilNotes,
            ...conBilRepNotes,
            ...cusUsageNotes,
            ...UsageRepNotes,
        ]);
    }, [consignmentBillingCustomerNotes, consignmentReplenishmentNotes]);

    useEffectWithErrorLogging(() => {
        if (lastModifiedDate && lastModifiedDate !== '') {
            setModifyDate(getDisplayDate(new Date(lastModifiedDate)));
            setModifyTime(convertTime24To12(new Date(lastModifiedDate)));
        }
    }, [lastModifiedDate]);
    return (
        <>
            {!isCondensedView && (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <OrderDetailTitle
                        margin={isCondensedView ? '10px 0 10px 3%' : '10px 0px 10px 0px'}
                        id="orders-orderdetail-tab-order-view-title"
                        fontFamily={
                            (orderBasicDetails?.currentOrderType === 'ZLC' ||
                                orderBasicDetails?.currentOrderType === 'MAST' ||
                                orderBasicDetails?.currentOrderType === 'ZLB') &&
                            (implantProducts?.length > 0 ||
                                instrumentProducts?.length > 0) &&
                            'AvenirNextWorld Regular'
                        }
                        fontWeight={
                            (orderBasicDetails?.currentOrderType === 'ZLC' ||
                                orderBasicDetails?.currentOrderType === 'MAST' ||
                                orderBasicDetails?.currentOrderType === 'ZLB') &&
                            (implantProducts?.length > 0 ||
                                instrumentProducts?.length > 0) &&
                            !isItemListView &&
                            '900'
                        }
                        borderBottomWidth={
                            (orderBasicDetails?.currentOrderType === 'ZLC' ||
                                orderBasicDetails?.currentOrderType === 'MAST' ||
                                orderBasicDetails?.currentOrderType === 'ZLB') &&
                            (implantProducts?.length > 0 ||
                                instrumentProducts?.length > 0) &&
                            !isItemListView &&
                            '2px'
                        }
                        borderBottom={
                            (orderBasicDetails?.currentOrderType === 'ZLC' ||
                                orderBasicDetails?.currentOrderType === 'MAST' ||
                                orderBasicDetails?.currentOrderType === 'ZLB') &&
                            (implantProducts?.length > 0 ||
                                instrumentProducts?.length > 0) &&
                            !isItemListView &&
                            '1px solid #1010EB'
                        }
                        cursor={
                            (orderBasicDetails?.currentOrderType === 'ZLC' ||
                                orderBasicDetails?.currentOrderType === 'MAST' ||
                                orderBasicDetails?.currentOrderType === 'ZLB') &&
                            (implantProducts?.length > 0 ||
                                instrumentProducts?.length > 0) &&
                            'pointer'
                        }
                        onClick={() => dispatch(setItemListView(false))}
                    >
                        {(orderBasicDetails?.currentOrderType === 'ZLC' ||
                            orderBasicDetails?.currentOrderType === 'MAST' ||
                            orderBasicDetails?.currentOrderType === 'ZLB') &&
                        (implantProducts?.length > 0 ||
                            instrumentProducts?.length > 0)
                            ? t('orders.orderSummaryTabs.OrderView')
                            : t('orders.orderSummaryTabs.orderDetails')}
                    </OrderDetailTitle>
                    {(orderBasicDetails?.currentOrderType === 'ZLC' ||
                        orderBasicDetails?.currentOrderType === 'MAST' ||
                        orderBasicDetails?.currentOrderType === 'ZLB') &&
                        (implantProducts?.length > 0 ||
                            instrumentProducts?.length > 0) && (
                            <OrderDetailTitle
                            id="orders-orderdetail-tab-item-list-view-title"
                                fontFamily={
                                    (orderBasicDetails?.currentOrderType ===
                                        'ZLC' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'MAST' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'ZLB') &&
                                    'AvenirNextWorld Regular'
                                }
                                fontWeight={
                                    (orderBasicDetails?.currentOrderType ===
                                        'ZLC' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'MAST' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'ZLB') &&
                                    isItemListView &&
                                    '900'
                                }
                                borderBottomWidth={
                                    (orderBasicDetails?.currentOrderType ===
                                        'ZLC' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'MAST' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'ZLB') &&
                                    isItemListView &&
                                    '2px'
                                }
                                borderBottom={
                                    (orderBasicDetails?.currentOrderType ===
                                        'ZLC' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'MAST' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'ZLB') &&
                                    isItemListView &&
                                    '1px solid #1010EB'
                                }
                                cursor={
                                    (orderBasicDetails?.currentOrderType ===
                                        'ZLC' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'MAST' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'ZLB') &&
                                    'pointer'
                                }
                                margin={'10px 0 10px 3%'}
                                onClick={() => dispatch(setItemListView(true))}
                            >
                                {t('orders.orderSummaryTabs.ItemListView')}
                            </OrderDetailTitle>
                        )}
                </div>
            )}
            {orderBasicDetails?.currentOrderType === 'KE' ||
            orderBasicDetails?.currentOrderType === 'ZKA' ? (
                <AccountGridContainer
                    container
                    justifyContent={'space-between'}
                    direction="row"
                    margin={'10px 0px 2px 0px'}
                >
                    <AccountGrid
                        item
                        xs={12}
                        sm={6}
                        md={7}
                        lg={7}
                        xl={7}
                        mobile={12}
                    >
                        <div style={{ display: 'flex' }}>
                            <AccountStatusDetails>
                                <img src={shippingStatusSVG} />
                            </AccountStatusDetails>
                            <AccountDetails isDemi>
                                {orderBasicDetails.orderStatusDescription}
                            </AccountDetails>
                        </div>
                    </AccountGrid>
                    <AccountGrid
                        item
                        xs={12}
                        sm={6}
                        md={5}
                        lg={5}
                        xl={4}
                        mobile={12}
                    >
                        <AccountTimeDetails isRegular>
                            {t('equity.surgery.createdBy')} <span className="orders-detail-created-by-dt-mask">{createdBy + ' '}</span>
                            <span
                                style={{
                                    letterSpacing: '0px',
                                    color: '#000000',
                                    opacity: '0.2',
                                }}
                            >
                                |
                            </span>
                            {' ' + getDisplayDate(createdByTime) + ' '}
                            <span
                                style={{
                                    letterSpacing: '0px',
                                    color: '#000000',
                                    opacity: '1',
                                }}
                            >
                                |
                            </span>
                            {' ' +
                                notesTimeFormatter(
                                    orderDescription[0].orderDate
                                        ? orderDescription[0].orderDate
                                        : createdByTime,
                                    true
                                ) +
                                ' IST'}
                        </AccountTimeDetails>
                    </AccountGrid>

                    {orderDescription && orderDescription?.length > 0 ? (
                        <>
                            {orderDescription.map((order) => {
                                return (
                                    <>
                                        <AccountSubGridContainer
                                            container
                                            justifyContent={'space-between'}
                                            direction="row"
                                            mbPaddingBottom={
                                                orderBasicDetails?.currentOrderType ===
                                                    'ZKA' && '12px'
                                            }
                                            isConsignment={
                                                orderBasicDetails?.currentOrderType ===
                                                'ZKA'
                                            }
                                        >
                                            <AccountSubGrid
                                                item
                                                xs={7}
                                                sm={4}
                                                md={4}
                                                lg={
                                                    orderBasicDetails?.currentOrderType ===
                                                    'ZKA'
                                                        ? 3
                                                        : 4
                                                }
                                                xl={
                                                    orderBasicDetails?.currentOrderType ===
                                                    'ZKA'
                                                        ? 3
                                                        : 4
                                                }
                                                mobile={7}
                                            >
                                                <div
                                                    style={{
                                                        marginTop:
                                                            winWidth <=
                                                            sizes.mobileDevice
                                                                ? '0'
                                                                : '16px',
                                                    }}
                                                >
                                                    <AccountBillingDetails
                                                        isDemi
                                                        isConsignment={
                                                            orderBasicDetails?.currentOrderType ===
                                                            'ZKA'
                                                        }
                                                    >
                                                        {orderBasicDetails?.currentOrderType ===
                                                            'ZKA' &&
                                                        winWidth <=
                                                            sizes.mobileDevice ? (
                                                            <ImageContainer
                                                                isConsignment={
                                                                    orderBasicDetails?.currentOrderType ===
                                                                    'ZKA'
                                                                }
                                                            >
                                                                <img
                                                                    src={
                                                                        TissueIcon
                                                                    }
                                                                    alt="T"
                                                                />{' '}
                                                            </ImageContainer>
                                                        ) : null}
                                                        {orderBasicDetails?.currentOrderType !==
                                                            'ZKA' &&
                                                            order.orderType}
                                                        {orderBasicDetails?.currentOrderType ==
                                                            'ZKA' &&
                                                            t(
                                                                'orders.orderQuickFilters.consignmentReturn.nameCaps'
                                                            )}{' '}
                                                    </AccountBillingDetails>
                                                    {order?.poNumber ? (
                                                        <AccountBillingDetails
                                                            isRegular
                                                            isConsignment={
                                                                orderBasicDetails?.currentOrderType ===
                                                                'ZKA'
                                                            }
                                                        >
                                                            {t(
                                                                'common.poNumber'
                                                            )}
                                                            <span className="orders-detail-po-number-dt-mask">{orderBasicDetails?.currentOrderType ===
                                                            'ZKA'
                                                                ? order?.poNumber?.replace(
                                                                      'Cons Return -',
                                                                      ''
                                                                  )
                                                                : order?.poNumber}</span>
                                                        </AccountBillingDetails>
                                                    ) : null}
                                                </div>
                                            </AccountSubGrid>

                                            <AccountSubGrid
                                                item
                                                xs={5}
                                                sm={2}
                                                md={3}
                                                lg={4}
                                                xl={4}
                                                mobile={5}
                                            >
                                                <AccountTitle
                                                    isConsignment={
                                                        orderBasicDetails?.currentOrderType ===
                                                        'ZKA'
                                                    }
                                                >
                                                    {order.shippingStatus}
                                                </AccountTitle>
                                                <AccountMobileTitle>
                                                    {order.shippingStatus}
                                                </AccountMobileTitle>
                                            </AccountSubGrid>

                                            <AccountSubGrid
                                                item
                                                xs={8}
                                                sm={
                                                    orderBasicDetails?.currentOrderType ===
                                                    'ZKA'
                                                        ? 5
                                                        : 4
                                                }
                                                md={
                                                    orderBasicDetails?.currentOrderType ===
                                                    'ZKA'
                                                        ? 5
                                                        : 3
                                                }
                                                lg={
                                                    orderBasicDetails?.currentOrderType ===
                                                    'ZKA'
                                                        ? 5
                                                        : 3
                                                }
                                                xl={
                                                    orderBasicDetails?.currentOrderType ===
                                                    'ZKA'
                                                        ? 4
                                                        : 3
                                                }
                                                mobile={8}
                                            >
                                                <AccountOrderDiv
                                                    alignItems={'flex-start'}
                                                    marginTop="16px"
                                                    marginLeft={
                                                        orderBasicDetails?.currentOrderType ===
                                                        'ZKA'
                                                            ? '44px'
                                                            : '0px'
                                                    }
                                                    justifyContent={
                                                        orderBasicDetails?.currentOrderType ===
                                                            'ZKA' && 'flex-end'
                                                    }
                                                >
                                                    {order.salesOrg ===
                                                    'S030' ? (
                                                        <ImageContainer>
                                                            <img
                                                                src={TissueIcon}
                                                                alt="T"
                                                            />
                                                        </ImageContainer>
                                                    ) : order.salesOrg ===
                                                      'S002' ? (
                                                        <ImageContainer>
                                                            <img
                                                                src={
                                                                    NonTissueIcon
                                                                }
                                                                alt="NT"
                                                            />
                                                        </ImageContainer>
                                                    ) : null}
                                                    <AccountOrderDetails
                                                        isDemi
                                                        marginTop="0px"
                                                        whitespace="nowrap"
                                                    >
                                                        {t(
                                                            'orders.shipTrackLabels.sapOrderId'
                                                        )}
                                                        {': '}
                                                    </AccountOrderDetails>
                                                    <AccountOrderDetails
                                                        isRegular
                                                        marginTop="0px"
                                                    >
                                                        {order.sapOrderId}
                                                    </AccountOrderDetails>
                                                </AccountOrderDiv>
                                                <AccountOrderMobileDiv
                                                    isConsignment={
                                                        orderBasicDetails?.currentOrderType ===
                                                            'KE' ||
                                                        orderBasicDetails.currentOrderType ===
                                                            'ZKA'
                                                    }
                                                >
                                                    <AccountOrderDetails
                                                        isDemi
                                                        marginLeft={
                                                            orderBasicDetails?.currentOrderType ===
                                                            'ZKA'
                                                                ? '30px'
                                                                : '0'
                                                        }
                                                        mbMarginTop={
                                                            orderBasicDetails?.currentOrderType ===
                                                                'ZKA' && '5px'
                                                        }
                                                    >
                                                        {t(
                                                            'orders.shipTrackLabels.sapOrderId'
                                                        )}
                                                        {': '}
                                                    </AccountOrderDetails>
                                                    <AccountOrderDetails
                                                        isRegular
                                                        marginLeft={'4px'}
                                                        mbMarginTop={
                                                            orderBasicDetails?.currentOrderType ===
                                                                'ZKA' && '5px'
                                                        }
                                                    >
                                                        {order.sapOrderId}
                                                    </AccountOrderDetails>
                                                </AccountOrderMobileDiv>
                                            </AccountSubGrid>
                                            {orderBasicDetails?.currentOrderType !==
                                                'ZKA' && (
                                                <AccountSubGrid
                                                    item
                                                    xs={4}
                                                    sm={2}
                                                    md={2}
                                                    lg={1}
                                                    xl={1}
                                                    mobile={4}
                                                    className={
                                                        orderBasicDetails?.currentOrderType ===
                                                        'KE'
                                                            ? 'PriceGrid'
                                                            : ''
                                                    }
                                                >
                                                    <PriceTitle>
                                                        {order.price
                                                            ? setCurrencyFormat(
                                                                  order.price
                                                              )
                                                            : null}
                                                    </PriceTitle>
                                                </AccountSubGrid>
                                            )}
                                        </AccountSubGridContainer>
                                    </>
                                );
                            })}
                        </>
                    ) : null}
                </AccountGridContainer>
            ) : (
                ''
            )}
            {isCondensedView && !isMobileView() && (
                <AccountGridContainer
                    container
                    justifyContent={'space-between'}
                    direction="row"
                    margin={'10px 0px 2px 0px'}
                >
                    <div
                        style={{
                            display: 'flex',
                            padding: '0.8rem 0.8rem 10px 0.8rem',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <div style={{ display: 'flex' }}>
                            <div
                            id="orders-orderdetail-tab-condensed-order-view-button"
                                style={{
                                    width: '110px',
                                    display: 'flex',
                                    marginRight: '20px',
                                    cursor: 'pointer',
                                    borderBottom:
                                        !isItemListView &&
                                        '2.5px solid #1010EB',
                                    justifyContent: 'center',
                                    fontSize: '12px',
                                    fontFamily: 'AvenirNextWorld Demi',
                                    color: !isItemListView
                                        ? '#030330'
                                        : '#77778F',
                                }}
                                onClick={() => {
                                    try {
                                    dispatch(setItemListView(false));
                                    } catch (error) {
                                          logErrorToConsole(error);
                                     }
                                }}
                            >
                                {t('orders.orderSummaryTabs.OrderView')}{' '}
                                {`(${getTotalQuantity(
                                    products?.filter(
                                        (d) =>
                                            d?.status !== 'キャンセル' &&
                                            d?.status?.toLowerCase() !==
                                                'cancel'
                                    )
                                )})`}
                            </div>
                            {itemListViewVisibility(
                                orderBasicDetails?.currentOrderType
                            ) && (
                                <div
                                id="orders-orderdetail-tab-condensed-item-list-view-button"
                                    style={{
                                        width: '110px',
                                        display: 'flex',
                                        cursor: 'pointer',
                                        borderBottom:
                                            isItemListView &&
                                            '2.5px solid #1010EB',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontFamily: 'AvenirNextWorld Demi',
                                        color: isItemListView
                                            ? '#030330'
                                            : '#77778F',
                                    }}
                                    onClick={() => {
                                        try {
                                        dispatch(setItemListView(true));
                                        } catch (error) {
                                          logErrorToConsole(error);
                                     }
                                    }}
                                >
                                    {t('orders.orderSummaryTabs.ItemListView')}{' '}
                                    {`(${getTotalCount(
                                        products?.filter(
                                            (d) =>
                                                d?.status !== 'キャンセル' &&
                                                d?.status?.toLowerCase() !==
                                                    'cancel'
                                        )
                                    )})`}
                                </div>
                            )}
                        </div>
                        <CollapsableCardImageContainer
                         id="orders-orderdetail-tab-condensed-products-view-toggle"
                            onClick={() => {
                                try {
                                toggleCard(
                                    'productsView',
                                    !expandedCard.productsView
                                );
                                } catch (error) {
                                          logErrorToConsole(error);
                                }
                            }}
                            src={DownArrowFilter}
                            alt="down-arrow"
                            isExpanded={expandedCard.productsView}
                            cursor={'pointer'}
                        />
                    </div>
                    {!isItemListView && expandedCard.productsView && (
                        <ListViewContainer
                            products={products}
                            handleSetItemClick={handleSetItemClick}
                            isOrderScreen={true}
                            isorderViewList={true}
                            orderType={orderBasicDetails?.currentOrderType}
                        />
                    )}
                    {isItemListView &&
                        expandedCard.productsView &&
                        itemListViewVisibility(
                            orderBasicDetails?.currentOrderType
                        ) && (
                            <ListViewContainer
                                products={products}
                                handleSetItemClick={handleSetItemClick}
                                isOrderScreen={true}
                                isOrderScreenListView={true}
                                orderType={orderBasicDetails?.currentOrderType}
                            />
                        )}
                </AccountGridContainer>
            )}
            {isCondensedView && isMobileView() && (
                <AccountGridContainer
                    container
                    justifyContent={'space-between'}
                    direction="row"
                    margin={'10px 0px 2px 0px'}
                >
                    <div
                        style={{
                            display: 'flex',
                            padding: '20px 20px 10px 20px',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <div style={{ display: 'flex' }}>
                            <div
                            id="orders-orderdetail-tab-condensed-mobile-order-view-button"
                                style={{
                                    width: '110px',
                                    display: 'flex',
                                    marginRight: '20px',
                                    cursor: 'pointer',
                                    borderBottom:
                                        !isItemListView &&
                                        '2.5px solid #1010EB',
                                    justifyContent: 'center',
                                    fontSize: '12px',
                                    fontFamily: 'AvenirNextWorld Demi',
                                    color: !isItemListView
                                        ? '#030330'
                                        : '#77778F',
                                }}
                                onClick={() => {
                                    try {
                                    dispatch(setItemListView(false));
                                    } catch (error) {
                                          logErrorToConsole(error);
                                     }
                                }}
                            >
                                {t('orders.orderSummaryTabs.OrderView')}{' '}
                                {`(${getTotalQuantity(
                                    products?.filter(
                                        (d) =>
                                            d?.status !== 'キャンセル' &&
                                            d?.status?.toLowerCase() !==
                                                'cancel'
                                    )
                                )})`}
                            </div>
                            {itemListViewVisibility(
                                orderBasicDetails?.currentOrderType
                            ) && (
                                <div
                                 id="orders-orderdetail-tab-condensed-mobile-item-list-view-button"
                                    style={{
                                        width: '110px',
                                        display: 'flex',
                                        cursor: 'pointer',
                                        borderBottom:
                                            isItemListView &&
                                            '2.5px solid #1010EB',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontFamily: 'AvenirNextWorld Demi',
                                        color: isItemListView
                                            ? '#030330'
                                            : '#77778F',
                                    }}
                                    onClick={() => {
                                        try {
                                        dispatch(setItemListView(true));
                                        } catch (error) {
                                          logErrorToConsole(error);
                                     }
                                    }}
                                >
                                    {`${t(
                                        'orders.orderSummaryTabs.ItemListView'
                                    )} (${getTotalCount(
                                        products?.filter(
                                            (d) =>
                                                d?.status !== 'キャンセル' &&
                                                d?.status?.toLowerCase() !==
                                                    'cancel'
                                        )
                                    )})`}
                                </div>
                            )}
                        </div>
                        <CollapsableCardImageContainer
                          id="orders-orderdetail-tab-condensed-mobile-products-view-toggle"
                            onClick={() => {
                                try {
                                toggleCard(
                                    'productsView',
                                    !expandedCard.productsView
                                );
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                            src={DownArrowFilter}
                            alt="down-arrow"
                            isExpanded={expandedCard.productsView}
                            cursor={'pointer'}
                        />
                    </div>
                    {(isItemListView
                        ? itemListData?.length > 0
                        : products?.length > 0) && (
                        <CartActionItems width={'100%'}>
                            <AddIcon
                                display={'flex'}
                                padding={'5px 5px 0px 0px'}
                            >
                                <img
                                    width="14px"
                                    height="14px"
                                    src={
                                        (
                                            isItemListView
                                            ? expandCollapse(expandedProductsItemList, itemListData, lastClickedActionItemList) ==='expand'
                                            : expandCollapse(expandedProducts, products, lastClickedAction) ==='expand'
                                        )
                                            ? ExpandAll
                                            : CollapseAll
                                    }
                                />
                            </AddIcon>
                            <Text
                             id="orders-orderdetail-tab-condensed-mobile-expand-collapse-all-text"
                                width={'83px'}
                                color={'#1010eb'}
                                fontSize={'14px'}
                                fontFamily={'AvenirNextWorld Demi'}
                                onClick={
                                    (
                                        isItemListView
                                            ? expandCollapse(expandedProductsItemList, itemListData, lastClickedActionItemList) ==='expand'
                                            : expandCollapse(expandedProducts, products, lastClickedAction) ==='expand'
                                    )
                                        ? isItemListView
                                            ? () => {
                                                  expandAllItemList();
                                              }
                                            : () => {
                                                  expandAll();
                                              }
                                        : isItemListView
                                        ? () => {
                                              collapseAllItemList();
                                          }
                                        : () => {
                                              collapseAll();
                                          }
                                }
                            >
                                {(
                                    isItemListView
                                    ? expandCollapse(expandedProductsItemList, itemListData, lastClickedActionItemList) ==='expand'
                                    : expandCollapse(expandedProducts, products, lastClickedAction) ==='expand'
                                )
                                    ? t('equity.cart.expandAll')
                                    : t('equity.cart.collapseAll')}
                            </Text>
                        </CartActionItems>
                    )}
                    {!isItemListView && expandedCard.productsView && (
                        // <ListViewContainer
                        //     products={products}
                        //     handleSetItemClick={handleSetItemClick}
                        //     isOrderScreen={true}
                        // />
                        <>
                            <CondensedMobileViewList
                                showCheckBox={false}
                                // section={'sets'}
                                tab={'sets'}
                                product={products}
                                handleSetItemClick={handleSetItemClick}
                                isOrderDetailTab={false}
                                isOrderScreen={true}
                                expandedProducts={expandedProducts}
                                setExpandedProducts={setExpandedProducts}
                                toggleProduct={toggleProduct}
                                orderType={orderBasicDetails?.currentOrderType}
                            />
                            <CondensedMobileViewList
                                showCheckBox={false}
                                // section={'sets'}
                                tab={'item'}
                                product={products}
                                handleSetItemClick={handleSetItemClick}
                                isOrderDetailTab={false}
                                isOrderScreen={true}
                                expandedProducts={expandedProducts}
                                setExpandedProducts={setExpandedProducts}
                                toggleProduct={toggleProduct}
                                orderType={orderBasicDetails?.currentOrderType}
                            />
                            <CondensedMobileViewList
                                showCheckBox={false}
                                // section={'sets'}
                                tab={'fees'}
                                product={products}
                                handleSetItemClick={handleSetItemClick}
                                isOrderDetailTab={false}
                                isOrderScreen={true}
                                expandedProducts={expandedProducts}
                                setExpandedProducts={setExpandedProducts}
                                toggleProduct={toggleProduct}
                                orderType={orderBasicDetails?.currentOrderType}
                            />
                        </>
                    )}
                    {isItemListView &&
                        expandedCard.productsView &&
                        itemListViewVisibility(
                            orderBasicDetails?.currentOrderType
                        ) && (
                            <CondensedMobileViewList
                                showCheckBox={false}
                                tab={'item'}
                                product={products}
                                handleSetItemClick={handleSetItemClick}
                                isOrderDetailTab={true}
                                isOrderScreen={true}
                                expandedProductsItemList={
                                    expandedProductsItemList
                                }
                                setExpandedProductsItemList={
                                    setExpandedProductsItemList
                                }
                                toggleProductItemList={toggleProductItemList}
                                orderType={orderBasicDetails?.currentOrderType}
                            />
                        )}
                </AccountGridContainer>
            )}

            {!isCondensedView && isSet?.length > 0 && !isItemListView ? (
                <SetsOrderDetail
                    toggleCard={toggleCard}
                    sets={sets}
                    handleSetItemClick={handleSetItemClick}
                    ordersList={ordersList}
                />
            ) : null}
            {/* {isExtras?.length > 0 && !isItemListView ? (
                <>
                    <ExtrasOrderDetail
                        toggleCard={toggleCard}
                        extras={extras}
                        handleSetItemClick={handleSetItemClick}
                        ordersList={ordersList}
                    />
                </>
            ) : null} */}

            {orderBasicDetails?.currentOrderType === 'KE' && (
                <>
                    <AccountDetailsSection
                    // toggleCard={toggleCard}
                    // ordersList={ordersList}
                    />
                </>
            )}
            {orderBasicDetails?.currentOrderType === 'KE' &&
            (isLongTermConsignment || isShortTermConsignment) ? (
                <ConsignmentTermData
                isConsignmentBilling={true}
                    term={
                        isLongTermConsignment
                            ? t('reportUsage.longTerm')
                            : isShortTermConsignment
                            ? t('reportUsage.shortTerm')
                            : ''
                    }
                />
            ) : null}

            {procedureDetail?.procedure &&
            orderBasicDetails?.currentOrderType === 'KE' ? (
                <ProcedureDetails
                    toggleCard={toggleCard}
                    isProcedureDetails={isProcedureDetails}
                    isConsignmentBilling={orderBasicDetails?.currentOrderType === 'KE'}
                />
            ) : null}

            {!isCondensedView && (
                <>
                    {implantProducts?.length > 0 &&
                        isItemListView &&
                        itemListViewVisibility(
                            orderBasicDetails?.currentOrderType
                        ) && (
                            <CollapsableCard
                                id="orders-orderDetailTab-orderDetailTab-implants"
                                title={`${t(
                                    'common.implants'
                                )} (${implantProducts
                                    ?.filter(
                                        (d) =>
                                            d?.status !== 'キャンセル' &&
                                            d?.status?.toLowerCase() !==
                                                'cancel'
                                    )
                                    ?.reduce(
                                        (sum, currentItem) =>
                                            sum +
                                            parseInt(currentItem.quantity),
                                        0
                                    )})`}
                                onClick={() =>
                                    toggleCard('implants', !implants)
                                }
                                isExpanded={implants}
                                padding={'16px 20px'}
                                cursor={'pointer'}
                            >
                                {implants && (
                                    <OrderDetailMainContainer>
                                        <ItemListView
                                            products={implantProducts}
                                            isOrderScreen={true}
                                            handleSetItemClick={
                                                handleSetItemClick
                                            }
                                        />
                                    </OrderDetailMainContainer>
                                )}
                            </CollapsableCard>
                        )}
                    {instrumentProducts?.length > 0 &&
                        isItemListView &&
                        itemListViewVisibility(
                            orderBasicDetails?.currentOrderType
                        ) && (
                            <CollapsableCard
                                id="orders-orderDetailTab-orderDetailTab-instruments"
                                title={`${t(
                                    'common.instruments'
                                )} (${instrumentProducts
                                    ?.filter(
                                        (d) =>
                                            d?.status !== 'キャンセル' &&
                                            d?.status?.toLowerCase() !==
                                                'cancel'
                                    )
                                    ?.reduce(
                                        (sum, currentItem) =>
                                            sum +
                                            parseInt(currentItem.quantity),
                                        0
                                    )})`}
                                onClick={() =>
                                    toggleCard('instruments', !instruments)
                                }
                                isExpanded={instruments}
                                padding={'16px 20px'}
                                cursor={'pointer'}
                            >
                                {instruments && (
                                    <OrderDetailMainContainer>
                                        <ItemListView
                                            products={instrumentProducts}
                                            isOrderScreen={true}
                                            handleSetItemClick={
                                                handleSetItemClick
                                            }
                                        />
                                    </OrderDetailMainContainer>
                                )}
                            </CollapsableCard>
                        )}
                </>
            )}
            {orderBasicDetails?.currentOrderType === 'ZKA' && (
                <>
                    <AccountDetailsSection
                        isConsignmentReturn={true}
                    // toggleCard={toggleCard}
                    // ordersList={ordersList}
                    />
                </>
            )}

            {!isCondensedView && isExtras?.length > 0 && !isItemListView ? (
                <>
                    <ExtrasOrderDetail
                        toggleCard={toggleCard}
                        extras={extras}
                        handleSetItemClick={handleSetItemClick}
                        ordersList={ordersList}
                    />
                </>
            ) : null}

            {orderBasicDetails?.currentOrderType === 'KE' && (
                <>
                    <BillingDetails
                        toggleCard={toggleCard}
                        billingDetails={billingDetails}
                        ordersList={ordersList}
                    />
                </>
            )}
            {orderBasicDetails?.currentOrderType === 'KE' && notes?.length > 0 && (
                <>
                    <SurgeryNotes
                        toggleCard={toggleCard}
                        isSurgeryNotes={isSurgeryNotes}
                        notes={notes}
                     isConsignmentBilling={orderBasicDetails?.currentOrderType === 'KE'}

                        currentOrderType={orderBasicDetails?.currentOrderType}
                    />
                </>
            )}

            {/* {(orderBasicDetails.currentOrderType === 'ZLB' || orderBasicDetails.currentOrderType === 'ZLCR') && (
                <>
                    <SurgeryNotes
                        toggleCard={toggleCard}
                        isSurgeryNotes={isSurgeryNotes}
                        notes={notes}
                        currentOrderType={orderBasicDetails.currentOrderType}
                    />
                </>
            )} */}

            {orderBasicDetails?.currentOrderType === 'KE' ||
            orderBasicDetails?.currentOrderType === 'ZOR' ||
            orderBasicDetails?.currentOrderType === 'ZKA' ? (
                <OrderDetailFooterContainer>
                    {lastModifiedBy || modifyDate || modifyTime ? (
                        <>
                            <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                                {isLanguageChanged && lastModifiedBy
                                    ? ''
                                    : t('orders.orderSummaryTabs.lastmodify')}
                            </InvoiceCreatedDetail>
                            {lastModifiedBy ? (
                                <>
                                    <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                                        {isLanguageChanged
                                            ? t(
                                                  'orders.orderSummaryTabs.lastmodify'
                                              )
                                            : t(
                                                  'orders.orderDetails.billingSummary.by'
                                              )}
                                    </InvoiceCreatedDetail>
                                    <InvoiceCreatedDetail
                                        margin={'0 2px 0 0'}
                                        isCreatedDateBy
                                    >
                                        {lastModifiedBy}
                                    </InvoiceCreatedDetail>
                                </>
                            ) : null}
                            <WrapperContainer>
                                {modifyDate ? (
                                    <InvoiceCreatedDetail
                                        margin={'0 2px 0 -1px'}
                                    >
                                        {modifyDate}
                                    </InvoiceCreatedDetail>
                                ) : null}
                                {modifyTime ? (
                                    <InvoiceCreatedDetail>
                                        {modifyTime}{' '}
                                        {orderBasicDetails?.currentOrderType ===
                                            'KE' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'ZKA' ||
                                        orderBasicDetails?.currentOrderType ===
                                            'ZOR'
                                            ? 'IST'
                                            : 'EDT'}
                                    </InvoiceCreatedDetail>
                                ) : null}
                            </WrapperContainer>
                        </>
                    ) : null}
                </OrderDetailFooterContainer>
            ) : null}
        </>
    );
};

export default OrderDetailTab;
